// extracted by mini-css-extract-plugin
module.exports = {"skeletonInline":"a_5q12clCxdgLNs2oa9hP","skeletonBlock":"_1d-lvfKd-aVaU1j4K1vAQA","shine-lines":"_2rB4PmqjS8BKIQnqmt-MtS","noBorderRadius":"_2YXeT2usIskDiWbWo-me7"};